import typeDefs from "./src/graphql/AlertSchema.gql";
import AlertService from "./src/components/AlertService";
import AlertBar from "./src/components/AlertBar.vue";
import resolvers from "./src/components/LocalResolvers";
import Vue from "vue";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";

const AlertPlugin = {
  install(theVue: typeof Vue, { apolloClient }: { apolloClient: ApolloClient<InMemoryCache> }) {
    theVue.prototype.$alertService = new AlertService(apolloClient);
  }
};

export { AlertService, typeDefs, resolvers, AlertPlugin, AlertBar };
